import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray, elGray } from '../../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace,
  SubNavContainer
} from 'app/src/elements';
import Modal from '../../../elements/Modal';
import NewRecurringSale from './new';

// const NavbarContainer = styled(View)`
//   display: flex;
//   flex-direction: row;

//   flex: 0.25;
//   align-items: center;
//   height: 5px;
//   background-color: ${elLightGray};
//   padding: 15px;
//   padding-left: 50px;
// `;

const TableNavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elGray};
  padding: 15px;
  padding-left: 15px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({recurringSale, refetch, tableNav}) => {
  const [showAddRecurringSaleModal, setShowAddRecurringSaleModal] = useState(false);
  const [showEditRecurringSaleModal, setShowEditRecurringSaleModal] = useState(false);
  const [showAddRecurringSaleAssetModal, setShowAddRecurringSaleAssetModal] = useState(false);
  const location = useLocation();
  return (
    <TableNavbarContainer style={{borderBottom: "solid"}}>
      {getLinks()}
    </TableNavbarContainer>
  )

  function getLinks() {
    if(location.pathname === '/sales/recurring-sales') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddRecurringSaleModal(true)}
          >
            <Text>+ Add Recurring Sale</Text>
          </Pressable>
          {showAddRecurringSaleModal &&
            <Modal
              showModal={showAddRecurringSaleModal}
              setShowModal={setShowAddRecurringSaleModal}
              modalType={'Add Recurring Sale'}
            >
              <NewRecurringSale
                setShowModal={setShowAddRecurringSaleModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === '/recurring-sales/new') {
      return (
        <Link to={`/sales/recurring-sales`}>
          <Text>Recurring Sales</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <Link to={`/sales/recurring-sales`}>
            <Text>Recurring Sales</Text>
          </Link>
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
